export const color = {
  primary1: "#FFBC00",
  primary2: "#FFCC00",
  primary3: "#60584C",
  
  secondary1: "#545045",
  secondary2: "#7D6948",
  secondary3: "#848687",

  neutral0: "#000000",
  neutral10: "#1C1B1F",
  neutral20: "#313033",
  neutral30: "#484649",
  neutral40: "#605D62",
  neutral50: "#787579",
  neutral60: "#939094",
  neutral70: "#AEAAAE",
  neutral80: "#C9C5CA",
  neutral90: "#E6E1E5",
  neutral95: "#F4EFF4",
  neutral99: "#FFFBFE",
  neutral100: "#FFFFFF",
};
export const textStyle = {
  h01: "normal normal 800 20px / 150% NanumSquareOTF",
  h02: "normal normal 700 18px / 100% NanumSquareOTF_ac",

  title01: "normal normal 800 17px / 140% NanumSquareOTF",
  title02: "normal normal 400 17px / 100% NanumSquareOTF",
  title03: "normal normal 700 15px / 100% NanumSquareOTF_ac",

  body01m: "normal normal 500 15px / 100% Noto Sans CJK KR",
  body01r: "normal normal 400 15px / 100% Noto Sans CJK KR",
  body02m: "normal normal 500 13px / 150% Noto Sans CJK KR",
  body02r: "normal normal 400 13px / 150% Noto Sans CJK KR",
  body03m: "normal normal 500 12px / 100% Noto Sans CJK KR",
  body03r: "normal normal 400 12px / 100% Noto Sans CJK KR",
};
